import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import logoNoxzi from "../../images/DA_Savoinimaux/logo.webp";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = () => setIsOpen(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <>
      <header className="sticky top-0 z-50 border-b border-black/6 bg-white/80 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
          <a href="/" className="flex items-center gap-4">
            <img
              src={logoNoxzi}
              alt="Logo Savoinimaux"
              className="h-14 w-auto object-contain"
              loading="lazy"
            />

            <div>
              <p className="text-base font-semibold tracking-[0.35em] text-[#111111]">
                SAVOINIMAUX
              </p>
              <p className="text-[10px] uppercase tracking-[0.42em] text-black/45">
                Depuis plus de 15ans
              </p>
            </div>
          </a>

          <nav className="hidden items-center gap-8 text-sm text-black/65 lg:flex">
            <a href="/" className="transition hover:text-red-600">
              Accueil
            </a>
            <a href="/#mission" className="transition hover:text-red-600">
              Mission
            </a>
            <a href="/#stories" className="transition hover:text-red-600">
              Histoires
            </a>
            <a href="/adoption" className="transition hover:text-red-600">
              Nos Chats
            </a>
            <a href="/partenaires" className="transition hover:text-red-600">
              Partenaires
            </a>
            <a href="/#contact-form" className="transition hover:text-red-600">
              Contact
            </a>
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="/#engagement"
              className="hidden rounded-full bg-red-600 px-5 py-3 text-sm font-semibold text-white shadow-[0_14px_40px_rgba(220,38,38,0.18)] transition hover:bg-red-500 lg:inline-flex"
            >
              Faire un don
            </a>

            <button
              onClick={() => setIsOpen(true)}
              className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-black/10 bg-white lg:hidden"
              aria-label="Ouvrir le menu"
            >
              <Menu className="h-5 w-5" />
            </button>
          </div>
        </div>
      </header>

      {/* Overlay mobile */}
      <div
        className={`fixed inset-0 z-[60] bg-black/40 backdrop-blur-sm transition duration-300 lg:hidden ${
          isOpen
            ? "pointer-events-auto opacity-100"
            : "pointer-events-none opacity-0"
        }`}
        onClick={closeMenu}
      />

      {/* Drawer mobile */}
      <div
        className={`fixed right-0 top-0 z-[70] h-screen w-[88%] max-w-[360px] border-l border-black/10 bg-white shadow-[0_20px_80px_rgba(0,0,0,0.15)] transition-transform duration-300 lg:hidden ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between border-b border-black/6 px-5 py-5">
          <div className="flex items-center gap-3">
            <img
              src={logoNoxzi}
              alt="Logo Savoinimaux"
              className="h-10 w-auto object-contain"
            />
            <div>
              <p className="text-sm font-semibold tracking-[0.22em] text-[#111111]">
                SAVOINIMAUX
              </p>
              <p className="text-[9px] uppercase tracking-[0.28em] text-black/45">
                Depuis plus de 12ans
              </p>
            </div>
          </div>

          <button
            onClick={closeMenu}
            className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-black/10 bg-white"
            aria-label="Fermer le menu"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <nav className="flex flex-col px-5 py-6">
          <a
            href="/"
            onClick={closeMenu}
            className="border-b border-black/6 py-4 text-base font-medium text-[#111111] transition hover:text-red-600"
          >
            Accueil
          </a>
          <a
            href="/#mission"
            onClick={closeMenu}
            className="border-b border-black/6 py-4 text-base font-medium text-[#111111] transition hover:text-red-600"
          >
            Mission
          </a>
          <a
            href="/#stories"
            onClick={closeMenu}
            className="border-b border-black/6 py-4 text-base font-medium text-[#111111] transition hover:text-red-600"
          >
            Histoires
          </a>
          <a href="/adoption"
          onClick={closeMenu}
            className="border-b border-black/6 py-4 text-base font-medium text-[#111111] transition hover:text-red-600"
            >Nos Chats</a>
          <a
            href="/partenaires"
            onClick={closeMenu}
            className="border-b border-black/6 py-4 text-base font-medium text-[#111111] transition hover:text-red-600"
          >
            Partenaires
          </a>
          <a
            href="/#contact-form"
            onClick={closeMenu}
            className="border-b border-black/6 py-4 text-base font-medium text-[#111111] transition hover:text-red-600"
          >
            Contact
          </a>

          <a
            href="/#engagement"
            onClick={closeMenu}
            className="mt-6 inline-flex items-center justify-center rounded-full bg-red-600 px-5 py-3 text-sm font-semibold text-white shadow-[0_14px_40px_rgba(220,38,38,0.18)] transition hover:bg-red-500"
          >
            Faire un don
          </a>
        </nav>
      </div>
    </>
  );
}